import React from 'react';
import classNames from 'classnames';
import ToolItemLabel from '../ToolItemLabel';
import { PopUp } from '@beisen/chaos-ui';
import SearchForm from '../../Form/SearchForm';
require('./SearchList.scss');
/*
    SearchList: 筛选列表组件

*/

export default class SearchList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleTouchSearchList = this.handleTouchSearchList.bind(this);

    this.submit = this.submit.bind(this);
    this.formBlurHandler = this.formBlurHandler.bind(this);
    this.resetLookupFormData = this.resetLookupFormData.bind(this);
    this.searchData = this.props.initSearchData || [];
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.isLookupAdvanced) {
      this.searchData = nextProps.initSearchData || [];
    }
  }

  handleTouchSearchList() {
    this.props.touchToolItem && this.props.touchToolItem();
    if (this.state.visible == false) {
      this.setState({ visible: true });
    }
  }

  handleClose() {
    this.setState({ visible: false });
  }

  handleCancel() {
    // 非高级lookup模式  取消筛选的时候需要还原tempSearchData 并且重置biz_data
    !this.props.isLookupAdvanced && this.props.actions.afterClearFn(this.props.searchFormData.cmp_id);
    this.setState({ visible: false });
  }

  /**
  * lookup高级搜索表单存放数据
  */
  formBlurHandler(value) {
    this.searchData.unshift(value);
    const data = this.searchData.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj['name']).indexOf(obj['name']) === pos;
    });
    this.searchData = data;
    this.props.storeAdvanceLookupTempData && this.props.storeAdvanceLookupTempData(this.searchData);
  }

  resetLookupFormData() {
    this.props.resetLookupFormData && this.props.resetLookupFormData();
  }

  submit() {
    this.props.onBlur && this.props.onBlur(this.searchData);
  }

  render() {
    const { highlight, translation } = this.props;

    return (
      <div className="tool-item-container" onClick={this.handleTouchSearchList}>
        <ToolItemLabel label={translation.searchList}
          type="fixed"
          highlight={highlight}
          iconName="m-sys-form-filter"
        />
        {this.state.visible ? <PopUp visible={this.state.visible}
          animation="right-slide-fade"
          maskAnimation="fade"
          cls='searchlist_popup'
          onClose={this.handleCancel}
          style={{ width: '85%', left: '15%' }}
          wrapClassName={classNames('searchlist_wrap', { 'bgOpacity': !this.state.visible })}
        >
          <SearchForm { ...this.props.searchFormData }
            pop_type="searchList"
            actions={this.props.actions}
            reloadTable={this.props.reloadTable}
            handleClosePopUp={this.handleClose}

            onBlur={this.formBlurHandler}
            submit={this.submit}
            resetLookupFormData={this.resetLookupFormData}
            isLookupAdvanced={this.props.isLookupAdvanced}
          />
        </PopUp> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ToolsBar/SearchList/SearchList.js